<template>
    <div class="grafico-container">
        <div class="grafico-header">
            <h3 class="grafico-titulo">Projetos por Gerente</h3>
            <GraficoInfoIcon 
                titulo="Projetos por Gerente"
                descricao="Mostra a quantidade de projetos sob responsabilidade de cada gerente, auxiliando na distribuição de carga de trabalho."
            />
        </div>
        <div v-if="!temDados" class="sem-dados">Nenhum dado disponível</div>
        <Bar v-else :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import GraficoInfoIcon from './GraficoInfoIcon.vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
    name: 'GraficoProjetosPorGerente',
    components: { Bar, GraficoInfoIcon },
    props: {
        projetos: {
            type: Array,
            default: () => []
        }
    },
    emits: ['clicar-projeto'],
    computed: {
        dadosPorGerente() {
            const gerentesMap = {};
            this.projetos.forEach(p => {
                const gerente = p.gerente?.name || 'Sem Gerente';
                gerentesMap[gerente] = (gerentesMap[gerente] || 0) + 1;
            });
            return Object.entries(gerentesMap)
                .map(([gerente, count]) => ({ gerente, count }))
                .sort((a, b) => b.count - a.count)
                .slice(0, 15);
        },
        temDados() {
            return this.dadosPorGerente.length > 0;
        },
        chartData() {
            const dados = this.dadosPorGerente;
            return {
                labels: dados.map(d => d.gerente.length > 25 ? d.gerente.substring(0, 25) + '...' : d.gerente),
                datasets: [{
                    label: 'Projetos',
                    data: dados.map(d => d.count),
                    backgroundColor: 'rgba(46, 204, 113, 0.6)',
                    borderColor: 'rgba(46, 204, 113, 1)',
                    borderWidth: 2
                }]
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return `Projetos: ${context.parsed.x}`;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Quantidade de Projetos'
                        },
                        ticks: {
                            stepSize: 1
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Gerentes'
                        }
                    }
                }
            };
        }
    }
};
</script>

<style scoped>
.grafico-container {
    background: var(--cor-bg, white);
    border: 1px solid var(--cor-separador, #ddd);
    border-radius: 8px;
    padding: 1.5rem;
    height: 500px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}

.grafico-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.grafico-titulo {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--cor-fonte, #333);
}

.sem-dados {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
}
</style>

